module.exports = __webpack_public_path__ + "static/media/logo.e1fd379d.png";